import { createSelector } from 'reselect'

export const getUnsavedValue = (state, props) => {
  if (!props.form) return null

  const unsavedValue = state.kanbo.unsavedChanges[props.form]

  if (!unsavedValue) return null

  return unsavedValue
}

export default () => createSelector(
  [getUnsavedValue],
  (unsavedValue) => {
    return {
      unsavedValue
    }
  }
)
